(() => {
  const config = document.getElementById('century-care-copy');
  if (!config) return;
  let copy;
  try { copy = JSON.parse(config.textContent); } catch { return; }
  const decoder = document.createElement('textarea');
  decoder.innerHTML = copy.shop || '';
  copy.shop = decoder.value.trim();

  const node = (tag, text, className) => {
    const element = document.createElement(tag);
    if (text) element.textContent = text;
    if (className) element.className = className;
    return element;
  };
  const link = (label, href) => {
    const element = node('a', label);
    element.href = href;
    return element;
  };
  const card = document.querySelector('.century-care-card');

  // Order-tracking app page: just add the eyebrow above the app's own title.
  if (copy.context === 'tracking') {
    const app = document.getElementById('pp-tracking-page-app') || document.querySelector('main');
    app?.closest('main')?.classList.add('century-care-tracking');
    return;
  }

  // Policy pages (native) or help pages rendered by the main-page section.
  let container = document.querySelector('.shopify-policy__container');
  let title = container?.querySelector('.shopify-policy__title');
  let body = container?.querySelector('.shopify-policy__body');
  if (!container) {
    const heading = document.querySelector('.main-page-title');
    container = heading?.parentElement;
    title = heading;
    body = container?.querySelector('.rte');
  }
  if (!container || !title || !body || container.dataset.careReady) return;
  container.dataset.careReady = 'true';
  container.classList.add('century-care-page');

  const eyebrow = node('p', copy.eyebrow, 'century-care-eyebrow');
  title.matches('h1') ? title.before(eyebrow) : title.prepend(eyebrow);

  // Treat bold-only paragraphs as section headings (common in pasted policy text).
  [...body.querySelectorAll('p')].forEach((p) => {
    const text = p.textContent.trim();
    const onlyStrong = p.children.length === 1 && ['STRONG', 'B'].includes(p.firstElementChild.tagName) &&
      p.firstElementChild.textContent.trim() === text;
    const isSignOff = text === copy.shop || !p.nextElementSibling;
    if (text && text.length < 90 && !isSignOff && (onlyStrong || /section-heading/.test(p.className))) {
      const h2 = node('h2', text);
      if (p.id) h2.id = p.id;
      p.replaceWith(h2);
    }
  });

  const headings = [...body.querySelectorAll('h2')].filter((h) => h.textContent.trim() !== copy.shop);
  if (headings.length > 2) {
    const contents = node('nav', '', 'century-care-contents');
    contents.setAttribute('aria-label', copy.contents);
    contents.append(node('p', copy.contents, 'century-care-label'));
    const list = node('ol');
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `policy-section-${index + 1}`;
      const item = node('li');
      item.append(link(heading.textContent.trim(), `#${heading.id}`));
      list.append(item);
    });
    contents.append(list);
    title.after(contents);
  }

  // Wrap wide tables so they never push the page sideways on mobile.
  body.querySelectorAll('table').forEach((table) => {
    if (table.parentElement.classList.contains('century-table')) return;
    const wrap = node('div', '', 'century-table');
    table.before(wrap);
    wrap.append(table);
  });

  if (card) container.append(card);

  const related = node('nav', '', 'century-care-related');
  related.setAttribute('aria-label', copy.policies);
  copy.links.filter((item) => item.url).forEach((item) => {
    const anchor = link(item.label, item.url);
    if (new URL(item.url, location.origin).pathname === location.pathname) anchor.setAttribute('aria-current', 'page');
    related.append(anchor);
  });
  container.append(related);
})();
